import DatabaseClustersListTable from '../openstack/components/database/DatabaseClustersListTable'
import AdminConsole from './components/admin-console/AdminConsole'
import HomePage from './components/home/HomePage'
import { AppPlugins } from 'app/constants'
import Plugin from 'core/plugins/plugin'
import { imageUrlRoot } from 'app/constants'
const opencloudLogo = `${imageUrlRoot}/opencloud/r-Icon-White-Square.png`
import { openstackRoutes, openstackNavItems } from '../openstack'
import AlertsListPage from './components/alerts/AlertsListPage'

const opencloudPlugin = new Plugin(
  AppPlugins.OpenCloud,
  'OpenCloud',
  '/ui/opencloud',
  opencloudLogo,
  'Rackspace OpenCloud',
)

export const opencloudRoutes = [
  ...openstackRoutes,
  {
    name: 'OpenCloud Dashboard',
    link: {
      path: '/home',
      exact: true,
      default: true,
    },
    component: HomePage,
  },
  {
    name: 'Admin Console',
    link: { path: '/:region/admin-console', exact: true },
    component: AdminConsole,
  },
  {
    name: 'Alerts',
    link: { path: '/:region/alerts', exact: true },
    component: AlertsListPage,
  },
  {
    name: 'Database Clusters',
    link: { path: '/:region/database-clusters', exact: true },
    component: DatabaseClustersListTable,
  },
]

// const databaseClusterNavItem = {
//   name: 'Database Clusters',
//   icon: 'database',
//   link: { path: '/database-clusters', definition: '/database-clusters/:tab' },
//   nestedLinks: [
//     {
//       name: 'Overview',
//       link: {
//         path: '/database-clusters',
//         definition: '/database-clusters',
//       },
//     },
//   ],
// }

const navItemsToHide = ['Home', 'Kubernetes', 'Orchestration']

const opencloudNavItems = [
  {
    name: 'Home',
    link: { path: '/home' },
    icon: 'house',
    displayInTopSection: true,
  },
  {
    name: 'Dashboard',
    link: { path: '/dashboard', definition: '/dashboard' },
    icon: 'gauge-circle-bolt',
  },
  ...openstackNavItems({ includeVMwareGateway: true }).filter(
    (item) => !navItemsToHide.includes(item.name),
  ),
]

opencloudPlugin.registerRoutes(opencloudRoutes)
opencloudPlugin.registerNavItems(opencloudNavItems)

export default opencloudPlugin
